module.exports = __webpack_public_path__ + "static/media/things-to-know-about-startup-business.da97a2b1.md";